import styled, { css } from 'styled-components'
import { Button } from '@sketch/components'

interface ExitFullscreenButtonProps {
  $showOnBottom: boolean
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: flex; /* Safari bug, ensures container expands to height 100% */
  flex-grow: 1; /* Safari bug, ensures container expands to height 100% */
`

export const exitFullscreenButtonStyle = css<ExitFullscreenButtonProps>(
  ({ $showOnBottom = false }) => css`
    color: white;
    position: absolute;
    ${$showOnBottom === false &&
    css`
      top: 8px;
    `}
    ${$showOnBottom &&
    css`
      bottom: 8px;
    `}
  right: 8px;
  `
)

export const ExitFullscreenButton = styled(Button)`
  ${exitFullscreenButtonStyle}
`
